import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import "./assets/tailwind.css";
import { store } from "./store/index.js";
import strings from "./assets/strings.js";
import axios from "axios";
import { PublicClientApplication } from "@azure/msal-browser";
import {
  create,
  NCard,
  NTabs,
  NTabPane,
  NLayout,
  NButton,
  NIcon,
  NModal,
  NForm,
  NFormItem,
  NInput,
  NDatePicker,
  NSelect,
  NRadioGroup,
  NRadio,
  NGrid,
  NFormItemGi,
  NDataTable,
  NMessageProvider,
  NGridItem,
  NDynamicTags,
  NLayoutSider,
  NMenu,
  NLayoutContent,
  NDialogProvider,
  NPagination,
  NDivider,
  NSkeleton,
  NRate,
  NBackTop,
  NSteps,
  NStep,
  NLi,
  NCollapse,
  NCollapseItem,
  NTag,
  NSpace,
  NUpload,
  NUploadDragger,
  NCheckboxGroup,
  NCheckbox,
  NInputNumber,
  NAutoComplete,
  NPopover,
} from "naive-ui";

const naive = create({
  components: [
    NCard,
    NTabs,
    NTabPane,
    NLayout,
    NButton,
    NIcon,
    NModal,
    NForm,
    NFormItem,
    NInput,
    NDatePicker,
    NSelect,
    NRadioGroup,
    NRadio,
    NGrid,
    NFormItemGi,
    NDataTable,
    NMessageProvider,
    NGridItem,
    NDynamicTags,
    NLayoutSider,
    NMenu,
    NLayoutContent,
    NDialogProvider,
    NPagination,
    NDivider,
    NSkeleton,
    NRate,
    NBackTop,
    NSteps,
    NStep,
    NLi,
    NCollapse,
    NCollapseItem,
    NTag,
    NSpace,
    NUpload,
    NUploadDragger,
    NCheckboxGroup,
    NCheckbox,
    NInputNumber,
    NAutoComplete,
    NPopover,
  ],
});

//axios.defaults.baseURL = "https://ucfsdsapi.herokuapp.com/api";
//axios.defaults.baseURL = "https://sdshowcase-api-preprod.azurewebsites.net/api";

// Anthony.P.Goodman Azure Account (Production)
//axios.defaults.baseURL = "https://ucf-cecs-sdshowcase-api-ebdbc9duc8ckf7h2.eastus2-01.azurewebsites.net/api";

// API URL from environment variable, with fallback for local development
axios.defaults.baseURL = process.env.VUE_APP_API_URL || "https://localhost:5001/api";

const app = createApp(App);
const msalInstance = new PublicClientApplication(
  store.getters.getMsalConfig
);

// Initialize MSAL and handle redirect responses
msalInstance.initialize().then(async () => {
  // Handle redirect response if user is returning from Microsoft login
  try {
    const redirectResponse = await msalInstance.handleRedirectPromise();

    if (redirectResponse !== null) {
      // User just completed authentication or logout
      console.log("Redirect response received:", redirectResponse);

      // Only set auth if there's an account (login), not for logout
      if (redirectResponse.account) {
        await store.dispatch("setAuth", redirectResponse);
        // Navigate to admin dashboard after successful login
        // Wait for app to mount before navigating
        setTimeout(() => {
          router.push('/admin');
        }, 100);
      } else {
        // Logout redirect - ensure state is cleared
        console.log("Logout redirect completed");
        store.dispatch("setAuth", null);
      }
    } else {
      // No redirect response - check if there's an existing session
      const accounts = msalInstance.getAllAccounts();

      // Only restore session if we have accounts AND valid token in localStorage
      // This prevents auto-login after logout
      const hasStoredToken = localStorage.getItem("accessToken");

      if (accounts.length > 0 && hasStoredToken) {
        // Try to silently acquire a token to verify the session is still valid
        try {
          const response = await msalInstance.acquireTokenSilent({
            account: accounts[0],
            scopes: ["api://25fab972-96ef-45d0-aaea-ecae30fa2aed/access_as_user"],
          });
          store.dispatch("setAuth", response);
        } catch (error) {
          console.error("Silent token acquisition failed:", error);
          // Token is invalid/expired - clear stale MSAL cache
          await msalInstance.clearCache();
          store.dispatch("setAuth", null);
        }
      } else if (accounts.length > 0 && !hasStoredToken) {
        // Stale MSAL cache without valid token - clear it
        console.log("Clearing stale MSAL cache");
        await msalInstance.clearCache();
      }
    }
  } catch (error) {
    console.error("Error handling redirect:", error);
  } finally {
    // Always mount the app, even if authentication failed
    app.config.globalProperties.$msalInstance = msalInstance;
    app.config.globalProperties.$strings = strings;
    app.use(router);
    app.use(naive);
    app.use(store);
    app.mount("#app");
  }
});
